import { useEffect, useRef } from 'react';

/** Balayage depuis le bord gauche (façon iPhone) : la page suit le doigt puis on revient à l'accueil du restaurant. */
export const useEdgeSwipeBack = ({ enabled, onBack, edge = 32, threshold = 96 }) => {
  const ref = useRef(null);
  const state = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!enabled || !el) return undefined;
    const hint = document.createElement('div');
    hint.className = 'swipe-back-hint';
    hint.setAttribute('data-testid', 'swipe-back-hint');
    hint.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>';
    document.body.appendChild(hint);
    const reset = () => { el.style.transition = 'transform .22s ease'; el.style.transform = ''; hint.classList.remove('is-on'); hint.style.transform = ''; state.current = null; };
    const start = (e) => {
      const t = e.touches[0];
      if (t.clientX > edge) return;
      state.current = { x: t.clientX, y: t.clientY, live: false };
      el.style.transition = 'none';
    };
    const move = (e) => {
      const s = state.current; if (!s) return;
      const t = e.touches[0]; const dx = t.clientX - s.x; const dy = Math.abs(t.clientY - s.y);
      if (!s.live) { if (dy > 24 && dy > dx) { state.current = null; return; } if (dx < 12) return; s.live = true; hint.classList.add('is-on'); }
      const shift = Math.max(0, dx) * 0.45;
      el.style.transform = `translateX(${shift}px)`;
      hint.style.transform = `translateX(${Math.min(dx, threshold) - threshold}px)`;
      hint.classList.toggle('is-ready', dx >= threshold);
      s.dx = dx;
    };
    const end = () => {
      const s = state.current; if (!s) return;
      const go = s.live && s.dx >= threshold;
      reset();
      if (go) onBack();
    };
    el.addEventListener('touchstart', start, { passive: true });
    el.addEventListener('touchmove', move, { passive: true });
    el.addEventListener('touchend', end);
    el.addEventListener('touchcancel', reset);
    return () => { el.removeEventListener('touchstart', start); el.removeEventListener('touchmove', move); el.removeEventListener('touchend', end); el.removeEventListener('touchcancel', reset); hint.remove(); };
  }, [enabled, onBack, edge, threshold]);
  return ref;
};
